import { formwizApi } from "./formwizApi";

// Form definitions by (form_id, version). A published version never changes
// (the server refuses to republish one with different content), so a fetched
// definition is kept for the life of the page. A failed fetch is forgotten so
// the next call retries.
const cache = new Map();

export function getDef(formId, version) {
  const key = `${formId}@${version}`;
  if (!cache.has(key)) {
    const p = formwizApi.def(formId, version).catch((e) => {
      cache.delete(key);
      throw e;
    });
    cache.set(key, p);
  }
  return cache.get(key);
}

export function clearDefsCache() {
  cache.clear();
}
